import { useEffect, useCallback } from "react";
import { useDispatch } from "react-redux";
import { listServers } from "./redux/actions/serverActions";

const ScheduledUpdate = () => {
  const dispatch = useDispatch();

  // Stable function — reads fresh values from localStorage each run
  const fetchServersAndUpdate = useCallback(() => {
    const selectedBusiness = localStorage.getItem("selectedBusiness");
    const user = localStorage.getItem("email");

    if (user && selectedBusiness) {
      dispatch(listServers({ user, selectedBusiness }));
    }
  }, [dispatch]);

  useEffect(() => {
    // Run immediately on mount
    fetchServersAndUpdate();

    const interval = setInterval(() => {
      fetchServersAndUpdate();
    }, 60 * 5 * 1000); // 5 minutes

    return () => clearInterval(interval);
  }, [fetchServersAndUpdate]);

  return null;
};

export default ScheduledUpdate;
